import "./RemodelingFaq.module.css";
import Header from "@/reusable_sections/Header";
import FaqHero from "./sections/FaqHero";
import RemodelingFaq from "./sections/RemodelingFaq";
import EstimateForm from "./sections/EstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function RemodelingFaqPage() {
  return <div>
      <Header />
      <FaqHero />
      <RemodelingFaq />
      <EstimateForm />
      <Footer />
    </div>;
}